import { Link, useParams } from 'react-router-dom';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from "../../../components/headerBtn/headerBtn";

import ProfileEmployee from '../../../pages/employees/profileEmployee/profileEmployee';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';

const EmployeeCreateSection = () => {
	const { id } = useParams<{ id: string }>();

	const overflowedBtnsCount = 0;

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Сохранить"
					purpose="6"
					modalTitle="Сохранить"
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content="Вернуться к списку"
					purpose="navigateToEmployeesList"
					modalTitle="Возврат к списку сотрудников"
				/>
			),
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: { component: JSX.Element }) => btn);

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={false}
				title='Создание нового сотрудника'
				pageName='projectInfo'
				section='Сотрудники'
			>
				<div className='content__main'>
					<div className={'btns'}>
						<Link to={`/employees/profile/${id}`} className='tab'>
							<div className='buttons__btn  --active'>Профиль</div>
						</Link>
					</div>
					<ProfileEmployee />
				</div>
			</SectionContent>
		</div>
	);
};

export default EmployeeCreateSection;